import React, { Fragment } from "react";
import CooperativesDetailInvoicesTable from "containers/cooperativesDetailInvoicesTable";
export default function() {
  return (
    <Fragment>
      <CooperativesDetailInvoicesTable />
    </Fragment>
  );
}